export type Message<P> = {
  type: string;
  payload: P;
  createdAt: number;
};

/** @see {isSuccessResponse} ts-auto-guard:type-guard */
export type SuccessResponse = {
  success: true;
  payload: unknown;
};

/** @see {isFailureResponse} ts-auto-guard:type-guard */
export type FailureResponse = {
  success: false;
  // cannot use Error because it's serialized to '{}' :D
  errorMessage: string;
};

/** @see {isResponse} ts-auto-guard:type-guard */
export type Response = SuccessResponse | FailureResponse;

export class HandlerError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, HandlerError.prototype);
  }
}
